import { ExpertsApplyModel } from "../../../domain/ExpertsApplyFormModel";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { buildDefinitions } from "../activityFeed/buildDefinitions/buildDefinitions";
import { ActivityType } from "../../../domain/ActivityType";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { DialogType, EntityDialog } from "../../types";
import { RenderDialog } from "../activityFeed/RenderDialog";


type MessageProps = {
  sms: ExpertsApplyModel;
  focusedEntity: EntityDialog | null;
  setFocussedEntity: (value: React.SetStateAction<EntityDialog | null>) => void;
}

export const Messages: React.FC<MessageProps> = ({ sms, focusedEntity, setFocussedEntity }) => {
  const definitions = buildDefinitions(sms,
    (activity) => setFocussedEntity({ dialogType: DialogType.SendPublicMessage, focusedActivity: activity })
  );

  const messageQueryParam: QueryParams = {
    activityTypes: [ActivityType.SpecialistOfqualSendPublicMessage, ActivityType.SpecialistCitizenSendPublicMessage],
  }

  return (
    <>
      <ActivityFeed
        resourceId={sms.id}
        definitions={definitions}
        params={messageQueryParam}
        actions={[
          {
            label: "New message",
            dataTest: "send-public-message-button",
            action: () =>
              setFocussedEntity({
                dialogType: DialogType.SendPublicMessage,
              })
          },
        ]}
      />
      <RenderDialog
        focusedEntity={focusedEntity}
        onClose={() => setFocussedEntity(null)}
        specialist={sms}
      />
    </>
  )
}
